
import crypto from 'crypto';
const hmac = crypto.createHmac('sha256', 'MesaJ_USsu_2021');
export function fillZero (value) {
    if (value<10){
        value="0"+value;
    }
    return value;
};

export function loginEvents(msisdn,status,code)
{
    let data = {
        'event': 'GAEvent',
        'eventCategory': 'Functions', 
        'eventAction': 'Login', 
        'eventLabel': status,
        'userId':getHashedMsisdn(msisdn)
    }
    if (status==="Failure")
    {
        data.errorType=code;
    }
    sendEvents(data);
}

export function registerEvents(msisdn,status,code)
{
    let data = {
        'event': 'GAEvent',
        'eventCategory': 'Functions', 
        'eventAction': 'Signup', 
        'eventLabel': status,
        'userId':getHashedMsisdn(msisdn)
    }
    if (status==="Failure")
    {
        data.errorType=code;
    }
    sendEvents(data);
}

function sendEvents(data)
{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
//     dataLayer.push({
//     'event': 'GAEvent',
//     'eventCategory': 'Functions', 
//     'eventAction': 'Signup', 
//     'eventLabel': 'Success', // Başarılı ise Success, başarısız ise Failure gönderilmelidir.
//     'userId': '123456', //Kullanıcının hashlenmiş MSISDN bilgisi gönderilmelidir.
//     'userCredit': 'Kredi Bilgisi' // Kullanıcının SMS kredi bilgisi gönderilmelidir.
// });
}


function getHashedMsisdn(msisdn)
{
        hmac.update(msisdn);
        return hmac.digest('hex');
}


export function turkishToUpper(s)
{
    var letters = {
        "i": "İ",
        "ş": "Ş",
        "ğ": "Ğ",
        "ü": "Ü",
        "ö": "Ö",
        "ç": "Ç",
        "ı": "I"
    };
    s = s.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
    })
    return s.toLocaleUpperCase('TR');
}